export class AccountInitialisationError extends Error {
  constructor(code, message) { super(message); this.code = code; }
}

export async function initialiseAccount(idToken, signal) {
  let endpoint = process.env.REACT_APP_ACCOUNT_API_URL;
  if (!endpoint) {
    const config = await fetch('/config/account.json', { cache: 'no-store', signal });
    if (!config.ok) throw new Error('Account service configuration is unavailable');
    endpoint = (await config.json()).accountApi;
  }
  const url = new URL(endpoint);
  if (url.protocol !== 'https:' && !['localhost', '127.0.0.1'].includes(url.hostname)) throw new Error('Invalid account service URL');
  const response = await fetch(`${url.href.replace(/\/$/, '')}/me/account`, {
    method: 'POST', headers: { Authorization: `Bearer ${idToken}` }, signal,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const messages = {
      email_verification_required: 'Please verify your email before setting up your ViewFinders account.',
      account_identity_conflict: 'We couldn’t link your account. Please contact ViewFinders for help.',
      invalid_account_attributes: 'We couldn’t finish your account setup. Please contact ViewFinders for help.',
    };
    throw new AccountInitialisationError(body.error || 'account_initialisation_failed', messages[body.error] || 'We couldn’t finish loading your ViewFinders account. Please try again.');
  }
  if (!body.account?.sub || !body.account.url_slug || !body.account.user_role) throw new Error('Invalid account response');
  return body.account;
}
